<template>
    <div class="dot-status">
        <div class=" fas fa-circle":class="testResultIcon" :title="tooltip ? form.name : ''" data-toggle="tooltip" data-placement="top"></div>
    </div>
</template>
<script>
    export default {

        props: {
            form: {
                type: Object,
                required: true,
            },
            tooltip:{
                type: Boolean,
                default : true,
            }
        },

        data() {
            return {
                test: this.form.test,
            }
        },

        mounted() {
            if(this.tooltip) {
                this.$nextTick(() => {
                    $('[data-toggle="tooltip"]').tooltip()
                })
            }
        },

        created() {
            Echo.channel(`test.status.${this.test.id}`).listen('TestStatusChanged', event => {
                this.test.status = event.status;
                if (event.alert) {
                    var type = (event.is_passed) ? 'success' : 'error'
                    Toast[type](`${this.form.name} ${this.ucfirst(event.status)}`)
                }
            });
        },

        computed: {
            testResultIcon() {
                return {
                    'text-success': this.test.status == 'passed',
                    'text-danger': this.test.status == 'fail',
                    'text-muted': this.test.status == 'empty',
                };
            }
        }
    }
</script>
